import axiosInstance from "@/api/axios";

export interface UserDetails {
  _id: string;
  email: string;
  status: number;
  companyName: string;
  fullName: string;
  phoneNumber: string;
  countryName: string;
  addressDetails?: string;
}

export const getUserDetails = async () => {
  try {
    const response = await axiosInstance({
      method: "GET",
      url: "/user/api/v1/user/getUserDetailsForProfile",
    });

    console.log("Get User Details Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching user details:", err);
  }
};

export const updateUserDetails = async (data: object) => {
  try {
    const response = await axiosInstance({
      method: "PUT",
      url: "/user/api/v1/user/updateUserProfileDetails",
      data,
    });

    console.log("Update User Details Response:", response);
    return response.data;
  } catch (err) {
    console.error("Error fetching user details:", err);
  }
};
